import { MultiSelectOption } from '../../../FormFields/MultiSelect';

export type AvailableFilters =
  | 'topics'
  | 'mediaTypes'
  | 'difficulties'
  | 'sortBy';

export interface FiltersOptions {
  topics: MultiSelectOption[];
  mediaTypes: MultiSelectOption[];
  difficulties: MultiSelectOption[];
  sortBy: MultiSelectOption[];
}

export interface SearchFilters {
  [index: string]: string[];
  topics: string[];
  mediaTypes: string[];
  difficulties: string[];
  sortBy: string[];
}

export const DEFAULT_FILTERS: SearchFilters = {
  topics: [],
  mediaTypes: [],
  difficulties: [],
  sortBy: []
};
